const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-6">About Us</h1>
          <p className="text-xl text-gray-300">Your trusted partner in luxury transportation</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <section className="mb-16">
            <h2 className="text-3xl font-semibold mb-6">Our Story</h2>
            <p className="text-gray-600 mb-4">
              Founded with a vision to redefine luxury transportation in Brussels, we have been providing exceptional chauffeur services to our distinguished clients. Our commitment to excellence and attention to detail has made us a preferred choice for those who value sophistication and reliability.
            </p>
          </section>

          <section className="mb-16">
            <h2 className="text-3xl font-semibold mb-6">Our Mission</h2>
            <p className="text-gray-600 mb-4">
              We strive to deliver unparalleled chauffeur services that exceed our clients' expectations. Through our professional team, luxury fleet, and dedication to customer satisfaction, we aim to make every journey memorable and comfortable.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold mb-6">Our Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-semibold mb-3">Excellence</h3>
                <p className="text-gray-600">We maintain the highest standards in every aspect of our service.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Reliability</h3>
                <p className="text-gray-600">Punctuality and dependability are at the core of our operations.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Discretion</h3>
                <p className="text-gray-600">We respect our clients' privacy and maintain professional confidentiality.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Innovation</h3>
                <p className="text-gray-600">We continuously improve our services to meet evolving client needs.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;